import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: { height: "100%" },
  saveBtn: { margin: theme.spacing(2) },
}));
